// export const API_BASE_URL = "http://localhost:8084";

export const API_BASE_URL = process.env.REACT_APP_API_URL_PORT;

//TimeSlipView API URLs
export const API_LATEST_RECORD_URL =`${API_BASE_URL}/event/get/latestRecord`;

export const API_LATEST_RACE_KEY_URL = `${API_BASE_URL}/api/v2/time-slips/latest-race-key`;

export const API_TIME_SLIP_URL = `${API_BASE_URL}/api/v2/time-slips/data`;

export const API_DELTA_VALUE_URL = `${API_BASE_URL}/api/v2/time-slips/delta-value`;

export const API_USER_URL = `${API_BASE_URL}/api/user`;

export const API_OAUTH2_URL = `${API_BASE_URL}/oauth2/authorization/azure`;

export const API_LOGOUT_URL = `${API_BASE_URL}/logout`;

export const API_PUBLIC_SIGNUP_URL = `${API_BASE_URL}/api/public/signup`;

export const TRACK_LIST_API = `${API_BASE_URL}/api/v2/tracks`;

export const API_CATEGORY_LIST_URL = `${API_BASE_URL}/api/v2/round-details/categories`;

export const API_ROUNDS_LIST_URL = `${API_BASE_URL}/api/v2/round-details/rounds`;

export const API_NAVIGATE_RACE_URL = `${API_BASE_URL}/api/v2/time-slips/navigate-race`;

export const API_TRACK_STATUS_URL = `${API_BASE_URL}/api/v2/tracks/status`;

export const API_RACE_CAR_COUNTS_URL = `${API_BASE_URL}/api/v2/time-slips/race-count`;

// export const API_SAVED_SEARCH_URL = `${API_BASE_URL}/api/v2/saved-searches`;
export const API_SAVED_SEARCH_URL = `${API_BASE_URL}/api/v2/saved-searches`;

export const API_WATCHLIST_URL = `${API_BASE_URL}/api/v2/watch-lists`;

export const API_CSRF_URL = `${API_BASE_URL}/api/csrf`;

export const API_KEY_FETCH_RACE_DATA = "pV7JFrS8L8EvCZsEI5WSraGtH1quQIa6YA6Wk9J6jYWavtx17ybzuYeGvo2fYPuYeeIFR1VtoJ5O1D81XgFEVnHQxaKdVjBWatQsaL703z0l3odm0SJ4CNRxyBLc39fm"


//SearchView API URLs
export const getSearchApiUrl = (searchPage) => {
  return `${API_BASE_URL}/api/v2/time-slips/search?page=${searchPage}`;
};

// Same search endpoint with an explicit page size. The backend defaults to
// size=20; the qualifying sheet pulls all runs for an event, so it requests
// large pages to minimize round-trips.
export const getSearchApiUrlWithSize = (page, size) => {
  return `${API_BASE_URL}/api/v2/time-slips/search?page=${page}&size=${size}`;
};

export const TRACK_LIST_API_test = `${API_BASE_URL}/api/v2/tracks`;

export const LATEST_TRACK_API = `${API_BASE_URL}/api/v2/events/latest`;

// Announcer API — used by LiveView to connect to Azure SignalR
export const ANNOUNCER_API_BASE_URL = process.env.REACT_APP_ANNOUNCER_API_URL;
export const LIVE_NEGOTIATE_URL    = `${API_BASE_URL}/api/negotiate`;
export const LIVE_TRACK_CONFIG_URL = `${API_BASE_URL}/api/getTrackBasedConfig`;




// Notification service (Spring Boot, polling-based) — powers the navbar bell.
// Falls back to localhost so it works out of the box in local dev.
export const NOTIFICATION_API_BASE_URL =
  process.env.REACT_APP_NOTIFICATION_API_URL || "http://localhost:8090";

export const NOTIFICATION_UNREAD_COUNT_URL = (userId, trackId, eventId) => {
  const params = new URLSearchParams();
  params.append("userId", userId);
  if (trackId != null) params.append("trackId", trackId);
  if (eventId != null) params.append("eventId", eventId);
  return `${NOTIFICATION_API_BASE_URL}/api/notifications/unread-count?${params.toString()}`;
};

export const NOTIFICATION_USER_URL = (userId, trackId, eventId) => {
  const params = new URLSearchParams();
  params.append("userId", userId);
  if (trackId != null) params.append("trackId", trackId);
  if (eventId != null) params.append("eventId", eventId);
  return `${NOTIFICATION_API_BASE_URL}/api/notifications/user?${params.toString()}`;
};

export const NOTIFICATION_MARK_READ_URL = (id, userId) => {
  const params = new URLSearchParams();
  params.append("userId", userId);
  return `${NOTIFICATION_API_BASE_URL}/api/notifications/${id}/read?${params.toString()}`;
};

export const NOTIFICATION_DOCUMENT_DOWNLOAD_URL = (docId) =>
  `${NOTIFICATION_API_BASE_URL}/api/documents/${docId}/url`;






